import type { INote } from '../../../../models/note.model';
import type { IOccupancy } from '../../../../models/occupancy.model';
import type { ITripLeg } from '../../../../models/trip-leg.model';
import { CallApiModel } from './call.api-model';
import { ServiceJourneyApiModel } from './service-journey.api-model';
import { type IPadamUrls } from '../../../../models/padam-urls';

export class TripLegApiModel {
  public static mapToBusinessModel(apiModel: TripLegApiModel): ITripLeg {
    return {
      origin: CallApiModel.mapToBusinessModel(apiModel.origin),
      destination: CallApiModel.mapToBusinessModel(apiModel.destination),
      isCancelled: apiModel.isCancelled,
      isPartCancelled: apiModel.isPartCancelled,
      estimatedDistanceInMeters: apiModel.estimatedDistanceInMeters,
      plannedConnectingTimeInMinutes: apiModel.plannedConnectingTimeInMinutes,
      estimatedConnectingTimeInMinutes: apiModel.estimatedConnectingTimeInMinutes,
      isRiskOfMissingConnection: apiModel.isRiskOfMissingConnection,
      serviceJourney: ServiceJourneyApiModel.mapToBusinessModel(apiModel.serviceJourney),
      plannedDepartureTime: apiModel.plannedDepartureTime,
      plannedArrivalTime: apiModel.plannedArrivalTime,
      estimatedDepartureTime: apiModel.estimatedDepartureTime,
      estimatedArrivalTime: apiModel.estimatedArrivalTime,
      plannedDurationInMinutes: apiModel.plannedDurationInMinutes,
      estimatedDurationInMinutes: apiModel.estimatedDurationInMinutes,
      notes: apiModel.notes,
      journeyLegIndex: apiModel.journeyLegIndex,
      occupancy: apiModel.occupancy ? apiModel.occupancy : undefined,
      // NV - 5212 - Buss on demand should be removed when trial period is over
      padamUrls: apiModel.padamUrls ? apiModel.padamUrls : undefined,
    };
  }

  public origin!: CallApiModel;
  public destination!: CallApiModel;
  public isCancelled!: boolean;
  public isPartCancelled!: boolean;
  public estimatedDistanceInMeters?: number;
  public plannedConnectingTimeInMinutes?: number;
  public estimatedConnectingTimeInMinutes?: number;
  public isRiskOfMissingConnection?: boolean;
  public serviceJourney!: ServiceJourneyApiModel;
  public plannedDepartureTime?: string;
  public plannedArrivalTime?: string;
  public estimatedDepartureTime?: string;
  public estimatedArrivalTime?: string;
  public plannedDurationInMinutes?: number;
  public estimatedDurationInMinutes?: number;
  public notes?: INote[];
  public journeyLegIndex!: number;
  public occupancy?: IOccupancy;
  // NV - 5212 - Buss on demand should be removed when trial period is over
  public padamUrls?: IPadamUrls;
  public estimatedOtherwisePlannedDepartureTime?: string;
  public estimatedOtherwisePlannedArrivalTime?: string;
}
